module.exports = __webpack_public_path__ + "media/images/main_blog-847799a436a62650a27f018fd2d63d63.png";